import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { dfpApiRef } from './api';
import { DfpApiClient } from './api/DfpApiClient';

import { rootRouteRef } from './routes';

export const dfpPlugin = createPlugin({
  id: 'dfp',
  apis: [
    createApiFactory({
      api: dfpApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, fetchApi, identityApi }) =>
        new DfpApiClient({ discoveryApi, fetchApi, identityApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});
export const DfpPage = dfpPlugin.provide(
  createRoutableExtension({
    name: 'DfpPage',
    component: () =>
      import('./components/Main').then(m => m.DfpPageLayout),
    mountPoint: rootRouteRef,
  }),
);

